
export default function ServiceDetailHead() {
  return (
    <>
    <section className="detailserv-head header-gap">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <span className="sub-tittle">Service</span>
                    <h1 className="heading">Bespoke Furniture</h1>
                    <p>Signature furniture, handcrafted to brief - statement pieces that belong to your space. Each design reflects your individuality, combining luxury materials and refined craftsmanship for furniture that lasts generations.</p>
                </div>
    
            </div>
        </div>

        <img src="/image/bespoke-banner.webp" loading="lazy" className="img-responsive" alt="service"/>
    </section>  
    </>
  )
}
